<template>
  <el-container>
    <el-header>
      <tab></tab>
    </el-header>
    <el-container :style="{ height: outer_height + 'px' }">
      <el-aside width="220px" v-show="isTabShow">
        <menus></menus>
      </el-aside>
      <el-main
        style="display: flex;flex-direction:column"
        :class="{ isTabShow: !isTabShow }"
      >
        <texts style="flex-shrink: 0" class="texts" v-show="isTabShow"></texts>
        <router-view style="flex: 1"></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      outer_height: document.documentElement.clientHeight - 60,
      timer: false,
    };
  },
  computed: mapState(["isTabShow"]),
  mounted() {
    const that = this;
    window.addEventListener("resize", function() {
      that.outer_height = document.documentElement.clientHeight - 60;
      that.$store.state.pub_height =
        document.documentElement.clientHeight - 105;
    });
  },
  watch: {
    outer_height(val) {
      if (!this.timer) {
        this.timer = true;
        let that = this;
        setTimeout(function() {
          that.timer = false;
        }, 400);
      }
    },
  },
  components: {
    tab: () =>
      import(/* webpackChunkName: "components" */ "@/components/tab.vue"),
    menus: () =>
      import(/* webpackChunkName: "components" */ "@/components/menu.vue"),
    texts: () =>
      import(/* webpackChunkName: "components" */ "@/components/text.vue"),
  },
};
</script>
<style lang="scss" scoped>
.el-aside {
  background-color: $menu-color;
}
.isTabShow {
  padding: 0px !important;
}
/deep/.el-main {
  overflow-x: hidden;
  overflow-y: auto;
  padding: 12px 20px 0px 20px;
  .texts {
    margin-bottom: 12px;
  }
}
</style>
